import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';

import preview from './estTradeCostComparisonPreview.png';
import preview2 from './estTradeCostComparisonPreview2.png';

export const estimatedTradeCostComparisonDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                This widget provides Cost and Risk for an order selection across
                a range of Benchmark and Profile combinations set up by the
                user.
            </div>
            <div>
                The widget uses our MAS Optimiser to estimate impact and risk
                for a given quantity (including any constraints). An optimal end
                time is also returned.
            </div>
            <div>
                Up to 6 comparisons can be configured in the widget settings.
                Each comparison is a benchmark and profile combination, along
                with other parameters such as Lit Participation and Strike Time.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            src: preview,
            altText: 'estimated-trade-cost-comparison-preview',
        },
        {
            src: preview2,
            altText: 'estimated-trade-cost-comparison-settings-preview',
        },
    ],
};
